<button
  data-testid="keyboard_shortcuts_btn_show_shortcuts"
  mat-menu-item
  (click)="showKeyboardShortcuts()"
>
  <mat-icon matListIcon>keyboard</mat-icon
  >{{ 'core.keyboard-shortcuts.menu-title' | translate }}
</button>
